import React, { useEffect, useRef, useState } from "react";

const SplashScreen = ({ onVideoEnd }) => {
  const videoRef = useRef(null);
  const [videoReady, setVideoReady] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onVideoEnd();
    }, 8000);

    const video = videoRef.current;
    if (video) {
      video.addEventListener("ended", () => { clearTimeout(timeout); onVideoEnd(); });
      video.addEventListener("error", () => { clearTimeout(timeout); onVideoEnd(); });
      video.addEventListener("playing", () => setVideoReady(true));
      video.addEventListener("canplay", () => {
        video.play().catch(() => { clearTimeout(timeout); onVideoEnd(); });
      });
    }

    return () => clearTimeout(timeout);
  }, [onVideoEnd]);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      backgroundColor: '#000000',
      overflow: 'hidden'
    }}>
      <video
        ref={videoRef}
        muted
        playsInline
        preload="auto"
        style={{
          position: 'absolute', inset: 0,
          width: '100%', height: '100%',
          objectFit: 'contain',
          backgroundColor: '#000000',
          opacity: videoReady ? 1 : 0,
          transition: 'opacity 0.3s ease',
        }}
      >
        <source src="/Assets/Video/Athena_Splash_Screen.mp4" type="video/mp4" />
      </video>
    </div>
  );
};

export default SplashScreen;